<template>
  <div class="base-setting">
    <pageHeader title="编辑个人信息" />
    <div class="cell-box">
      <div
        class="cell-item"
        v-for="item in cellList"
        :key="item.key"
        @click="doOperate(item)"
      >
        <div class="cell-item-container">
          <span class="cell-span">{{ item.label }}</span>
        </div>
        <div class="cell-user-info">
          <span v-if="item.key == 'nickname'">{{ nickName }}</span>
          <img
            v-if="item.key == 'logo'"
            :src="
              imgUrl ? imgUrl : require('@/assets/images/default_avatar.png')
            "
            class="logo"
            alt=""
          />
          <img class="arrow" src="@/assets/images/arrow.png" alt="" />
        </div>
      </div>
    </div>

    <div class="submit-btn" @click="submit">完成</div>
    
    <!-- 上传头像组件 -->
    <van-action-sheet
      v-model="avatarShow"
      :actions="avatarActions"
      cancel-text="取消"
      close-on-click-action
      @select="avatarSelect"
      class="action-sheet-container"
    >
      <div class="abs-input">
        <div><input @change="handleFileChange" type="file" accept="image/*" capture="camera" /></div>
        <div><input @change="handleFileChange" type="file" accept="image/*" /></div>
      </div>
    </van-action-sheet>

    <!-- 修改昵称弹窗 -->
    <van-dialog
      v-model="showDialog"
      title="更改昵称"
      show-cancel-button
      width="300px"
      confirm-button-color="#666666"
      cancel-button-color="#BBBBBB"
      @confirm="codeEvent"
    >
      <div class="code-input">
        <van-field v-model="changeNickName" :placeholder="nickName" size="small"></van-field>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      imgUrl: "",
      nickName: "",
      changeNickName: '',
      cellList: [
        {
          label: "头像",
          key: "logo",
        },
        {
          label: "昵称",
          key: "nickname",
        },
      ],
      avatarShow: false,
      avatarActions: [
        {name: '拍照'},
        {name: '相册选择'}
      ],
      showDialog: false,
      ossInfo: {}
    };
  },
  computed: {
    ...mapGetters(["userInfo", "uuid"]),
  },
  mounted() {
    this.userInfoQr();
  },
  methods: {
    /**
     * 编辑用户昵称和头像
     */
    async updateUserBaseInfo() {
      try {
        await requestMethods("/modules/user/user/editNickName.htm", "post", {
          uuid: this.uuid,
          imgUrl: this.imgUrl,
          nickName: this.nickName,
        });
      } catch (err) {
        this.$toast(err.message);
      }
    },
    /**
     * 查询个人用户信息
     */
    async userInfoQr() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/getUserInfo.htm",
          "post",
          {
            uuid: this.uuid,
          }
        );
        const { nickName, userImg } = data;
        this.imgUrl = userImg || "";
        this.nickName = nickName;
      } catch (err) {
        this.$toast(err.message);
      }
    },

    async handleFileChange(event) {
      const { ossInfo } = await this.getUploadAuth()
      const file = event.target.files[0];
      console.log(file, 'file')
      if(file) {
        let formData = new FormData()
        formData.append('key', ossInfo.dir)
        formData.append('OSSAccessKeyId', ossInfo.accessid)
        formData.append('signature', ossInfo.signature)
        formData.append('policy', ossInfo.policy)
        formData.append('callback', ossInfo.callback)
        formData.append('success_action_status', '200')
        formData.append('name', file.name)
        formData.append('file', file)
        let xhr = new XMLHttpRequest()
        xhr.open("post", `${ossInfo.host}`, true)
        xhr.onload = () => {
          let res = xhr.responseText
          if(res) {
            let backRes = JSON.parse(res)
            console.log(backRes)
            this.imgUrl = backRes.previewUrl
            this.avatarShow = false
          }
        }
        xhr.send(formData)
      }
      // if (file) {
      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     console.log("选中的图片:", e.target.result);
      //     // 这里可以将图片进行预览或上传处理
      //   };
      //   reader.readAsDataURL(file);
      // }
    },

    avatarSelect(e) {
      console.log(e)
    },

    codeEvent() {
      this.nickName = this.changeNickName
    },
    /**
     * 提交
     */
    async submit() {
      await this.updateUserBaseInfo()
      this.$router.go(-1)
    },

    doOperate(operate) {
        if(operate.key == 'logo') {
            this.avatarShow = true
        }
        if(operate.key == 'nickname') {
            this.showDialog = true
        }
    },

    async getUploadAuth() {
      try {
        const { data } = await requestMethods(
          "http://47.111.22.43:8082/oss/getOssPolicy.html",
          "post",
          {
            type: 'data/img/personal',
            suffix: 'png'
          }
        );
        console.log(data, 'data---')
        return {
          ossInfo: data
        }
        // this.ossInfo = data
      } catch (err) {
        this.$toast(err.message);
      }
    }
  },
};
</script>

<style lang="scss">
.base-setting {
  .cell-box {
    padding: 0 40px;
  }
  .cell-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 120px;
    border-bottom: 1px solid #eeeeee;

    .cell-item-container {
      display: flex;
      align-items: center;

      .cell-span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #8f8f8f;
      }
    }
    .cell-user-info {
      display: flex;
      align-items: center;
      .logo {
        width: 100px;
        height: 100px;
      }
      .arrow {
        width: 22px;
        height: 36px;
        margin-left: 18px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 32px;
        color: #000000;
        line-height: 45px;
      }
    }
  }

  .submit-btn {
    position: fixed;
    bottom: 70px;
    left: 75px;
    width: 600px;
    height: 80px;
    background: #ff7a3e;
    border-radius: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #ffffff;
    text-align: center;
    line-height: 80px;
  }

  .action-sheet-container {
    .abs-input {
        position: absolute;
        top: 0px;
        div {
            height: 100px;
            width: 750px;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
        }
    }
  }
  .van-dialog {
    .van-button {
        background: #F4F4F4;
    }
  }
  .code-input {
    padding: 40px 80px;
    margin: 0 auto;

    .van-cell {
    //   width: 400px;
    //   // height: 70px;
    //   background: #fafafa;
    //   border: 2px solid #dfdfdf;
      padding: 10px 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/baseSetting/index.vue